import {
  FilterState,
  ResearchId,
} from "../../../adapters/insights-agent/state/AppState.ts";
import { useInsightsAgentService } from "../../../adapters/insights-agent/state/hooks/useInsightsAgentService.tsx";
import { FilterChips } from "../../../feature-components/FilterChips/FilterChips.tsx";

export const ConnectedFilterChips = (props: {
  filterState: FilterState;
  researchId: ResearchId;
}) => {
  const appService = useInsightsAgentService();
  return (
    <FilterChips
      filterState={props.filterState}
      onDelete={(newState) => {
        appService
          .setFilters({
            researchId: props.researchId,
            filters: newState,
          })
          .then();
      }}
    />
  );
};
